<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-10 13:44:40
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Event\EventPropertyGroup\EventPropertyGroup.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-18 15:46:36
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_eventPropertyGroup_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-event-policy-group')"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    :exportBtn="hasBtn('export-admin-event-policy-group')"
    :importBtn="hasBtn('import-admin-event-policy-group')"
    :import-options="{
      api: '/event-property-group/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/event-group-import-template.xlsx',
      success: (result) => {
        getList(null, 1, $tableSetting.perPageSize, () => {
          $store.dispatch('resetTable', new Date().getTime());
        });
      },
    }"
    @export="onExport"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :items="desserts"
        :filter-page-data="filterPageData"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.event_property_group_name)"
          >
            {{ $getCommonLangValue(item.event_property_group_name) }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getCommonLangValue(item.event_property_group_description) }}
          </div>
        </template>
        <template v-slot:item.code="{ item }">
          <div class="text--primary table-title">
            {{ item.event_property_group_code }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-event-policy-group')"
            :viewBtn="hasBtn('delete-admin-event-policy-group')"
            :editBtn="hasBtn('edit-admin-event-policy-group')"
            :title="$t('label_essweb_eventPropertyGroup_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
    <!-- content -->
    <!-- tools -->
    <template v-slot:tools-main></template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "EventPropertyGroup",
  computed: {},
  data() {
    return {
      search: "",
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_eventPropertyGroup_list_eventPropertyGroupNameLabel",
          sortable: false,
          align: "start",
          value: "name",
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.event_property_group_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_eventPropertyGroup_form_eventPropertyGroupCodeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label:
            "label_essweb_eventPropertyGroup_list_eventPropertyGroupNameLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 1,
          name: "code",
          position: "right",
          label:
            "label_essweb_eventPropertyGroup_form_eventPropertyGroupCodeLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
      filterPageData: null,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["event_property_group_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["event_property_group_code"] = item.value;
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    onExport() {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["event_property_group_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["event_property_group_code"] = item.value;
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/export/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_eventPropertyGroup_list_title"),
      });
    },
    toNew: function () {
      this.$toPage("/admin/event-policy/add", {});
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/get-event-property-group-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/delete-event-property-group-table/",
        data: { uuids: id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_eventPropertyGroup_list_deleteEventPropertyGroupSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/event-policy/edit/"
          : "/admin/event-policy/detail/") + uuid
      );
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
